module.exports = require('./helpers/bundle-url').getBundleURL('8B7sB') + "logo.7718c6df.svg";